import { getReqMessage } from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (id) => {
    return !id
        ? {
              approvalStatusId: {
                  error: true,
                  message: getReqMessage('An approval status')
              }
          }
        : {};
};
